import { Injectable, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { SeatmapStoreModel } from '@common/interfaces/servicing-seatmap/seatmap-store-model';
import {
  selectServicingSeatmapBackupState,
  ServicingSeatmapBackupStore,
  setServicingSeatmapBackup,
  updateServicingSeatmapBackup,
} from '@common/store/servicing-seatmap-backup';

@Injectable({
  providedIn: 'root',
})
export class ServicingSeatmapBackupStoreService implements OnDestroy {
  private _subscriptions: Subscription[] = [];
  private _servicingSeatmapBackup$: Observable<SeatmapStoreModel>;
  private _servicingSeatmapBackup: SeatmapStoreModel = {};
  public get servicingSeatmapBackup(): SeatmapStoreModel {
    return this._servicingSeatmapBackup;
  }
  constructor(private _store: Store<ServicingSeatmapBackupStore>) {
    this._servicingSeatmapBackup$ = this._store.pipe(
      select(selectServicingSeatmapBackupState),
      map((state) => state.model || {})
    );
    this._subscriptions.push(
      this._servicingSeatmapBackup$.subscribe((data) => {
        this._servicingSeatmapBackup = data;
      })
    );
  }

  /**
   * バックアップ用サービシングシートマップStoreのモデルを取得するObservableを取得
   * @returns サービシングシートマップStoreのモデルを取得するObservable
   */
  public getServicingSeatmapBackupModel$(): Observable<SeatmapStoreModel> {
    return this._servicingSeatmapBackup$;
  }

  /**
   * バックアップ用サービシングシートマップStoreを指定された状態に上書きする
   * @param model 上書きを行うModel
   */
  public setServicingSeatmapBackup(model: SeatmapStoreModel) {
    this._store.dispatch(setServicingSeatmapBackup({ model }));
  }

  /**
   * バックアップ用サービシングシートマップStoreの指定されたパラメータを更新する
   * @param model 更新を行うModel
   */
  public updateServicingSeatmapBackup(model: SeatmapStoreModel) {
    this._store.dispatch(
      updateServicingSeatmapBackup({
        model: {
          ...this._servicingSeatmapBackup,
          ...model,
        },
      })
    );
  }

  ngOnDestroy(): void {
    this._subscriptions
      .filter((subscription) => subscription != null)
      .forEach((subscription) => subscription.unsubscribe());
  }
}